import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { formatApiError } from "../../lib/api";

export default function Activation() {
    const { token } = useParams();
    const [context, setContext] = useState(null);
    const [error, setError] = useState("");
    const [password, setPassword] = useState("");
    const [confirmation, setConfirmation] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [complete, setComplete] = useState(false);

    useEffect(() => {
        api.get(`/auth/activate/${token}`).then(({ data }) => setContext(data)).catch((e) => setError(formatApiError(e)));
    }, [token]);

    const submit = async (event) => {
        event.preventDefault(); setError("");
        if (password !== confirmation) { setError("Les mots de passe ne correspondent pas"); return; }
        setSubmitting(true);
        try {
            await api.post(`/auth/activate/${token}`, { password, password_confirmation: confirmation });
            setPassword(""); setConfirmation(""); setComplete(true);
        } catch (e) { setError(formatApiError(e)); } finally { setSubmitting(false); }
    };

    return <main className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <section className="w-full max-w-md rounded-2xl bg-white border border-slate-200 shadow-sm p-7">
            <h1 className="text-2xl font-bold text-slate-900">Activation du compte parent</h1>
            {complete ? <div className="mt-6"><p className="text-emerald-700 font-semibold">Votre compte est activé</p><Link className="mt-5 inline-block text-orange-600 font-medium" to="/login">Se connecter</Link></div> : error && !context ? <div className="mt-6"><p className="text-red-600">{error}</p><Link className="mt-5 inline-block text-orange-600" to="/login">Retour à la connexion</Link></div> : !context ? <p className="mt-6 text-slate-600">Vérification de l’invitation…</p> : <form className="mt-6 space-y-4" onSubmit={submit}>
                <p className="text-sm text-slate-600">Compte de <strong>{context.full_name}</strong> · {context.email}</p>
                <label className="block text-sm font-medium">Nouveau mot de passe<input className="mt-1 w-full rounded-lg border p-3" type="password" minLength="8" maxLength="128" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
                <label className="block text-sm font-medium">Confirmer le mot de passe<input className="mt-1 w-full rounded-lg border p-3" type="password" minLength="8" maxLength="128" autoComplete="new-password" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} required /></label>
                {error && <p className="text-sm text-red-600">{error}</p>}
                <button className="w-full rounded-lg bg-orange-600 text-white font-semibold p-3 disabled:opacity-50" disabled={submitting}>{submitting ? "Activation…" : "Activer mon compte"}</button>
            </form>}
        </section>
    </main>;
}
